export const schemaIPH_CSV = {
  defaults: {
    headerRows: 0, //amount rows till userfull data 
    schemaKey: "iph_csv",
    sellerId: 152,
    loadAtId: 152,
    packingId: 2,
    cargoTypeId: 1,
  },
  mapping: {
    masterBill: "awb",
    voyage: "flight",
    packs: "boxes",
    fullBoxes: "boxesControle",
    weight: "brutto",
    chargable: "chargableWeight",
    orderReference: "packingCode",
    origin: "countryId",
    houseBillNumber: "hawb",
    consignee: "consignee",
    eta: "date",
    consignor: "consignor",
    shipmentID: "shipmentID",
  },
};



// WEBPACK FOOTER //
// ./src/schemas/schema_IPH_CSV.js